<template>
  <div id="resources_href" class="resource-bg w-full bg-center"></div>
  <div class="resources-bg-color pb-20">
    <div class="max-w-7xl mx-auto">
      <div class="mx-10 pt-20">
        <div class="flex justify-center sm:justify-start">
          <img src="@/assets/title-resource.svg" alt="線上資源" class="mb-12" />
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <!-- 第一筆線上資源 -->
          <div v-for="resource in resources" :key="resource.id" class="sm:flex">
            <div class="flex justify-center">
              <div
                class="
                  book-size
                  bg-white
                  flex flex-none
                  items-center
                  justify-center
                "
              >
                <img v-if="resource.image_url.length !== 0" :src="resource.image_url" alt="線上資源縮圖" class="book" />
                <img v-else src="@/assets/book1.png" alt="線上資源預設縮圖" class="book" />
              </div>
            </div>
            <div class="mt-5 sm:mt-0 sm:ml-5">
              <div class="text-center">
                <p
                  class="text-center text-xl font-black sm:text-left"
                >
                  {{ resource.title }}
                </p>
              </div>
              <p class="text-left text-lg hidden sm:block">
                {{ resource.content }}
              </p>
              <div class="mt-5 flex justify-center sm:justify-end">
                <button @click="openResource(resource.id);" target="_blank">
                <div
                  class="
                    download-btn
                    text-white
                    flex
                    items-center
                    justify-center
                  "
                >
                  Download
                </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="resource-bg-bottom w-full bg-center"></div>
</template>

<script>
import { getResources, downloadResource } from '@/api/web-resource'

export default {
  name: "Resources",

  data() {
    return {
      content: "",
      resources: [],
      loadingData: false,
    };
  },

  mounted() {
    getResources().then(
      (response) => {
        this.resources = response.data;
        this.loadingData = true
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },

  methods: {
    openResource(id) {
      downloadResource(id).then(response => {
        window.open(response.url, '_blank')
      }).catch(response => {
        console.log('downloadResource failed', id)
      })
    },
  },
};
</script>

<style scoped>
.resource-bg {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/resource-bg.svg");
}

.resource-bg-bottom {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/resource-bg-bottom.svg");
}

.resources-bg-color {
  background-color: #b1c5d2;
}

.book-size {
  width: 180px;
  height: 282px;
}

.book {
  width: 160px;
  height: 262px;
}

.download-btn {
  width: 125px;
  height: 50px;
  background-color: #c9a798;
  mask-image: url(../../assets/btn-bg.svg);
}

.download-btn:hover {
  background-color: #a8897c;
}
</style>
